import { WorkingRoster } from '@/types/roster.types';
import { buildEmployeeSummaryDayStats, RosterEmployeesSummaryDayStats } from './buildEmployeeSummaryDayStats';
import { SummaryEmployee } from './summary.types';

export interface RosterSummaryDayStats extends RosterEmployeesSummaryDayStats {
  totalStaffRostered?: number;
  totalShifts?: number;
}

export const buildRosterDayStats = (summary: SummaryEmployee[], dates: Date[], roster?: WorkingRoster) => {
  const employeeDayStats = buildEmployeeSummaryDayStats(summary, dates);
  const totalShifts = roster?.shifts.length || 0;
  const totalRosteredShifts = roster?.shifts.filter(
    shift => shift.assignedEmployeeId || shift.assignedContractRoleId || shift.assignedContractId
  ).length;

  const stats = { ...employeeDayStats[0], totalStaffRostered: totalRosteredShifts, totalShifts };
  return stats;
};
